import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
/** 
 * Language Pipe  
  */
@Pipe({
  name: 'lang'
})

export class LangPipe implements PipeTransform {

  constructor(public utils: UtilsService) { }

  transform(value: any, args?: any): any {
    let key = args;
    return this.utils.langData != null ? this.utils.langData[key] || value : value;
  }

}
